export const APP_NAME = 'Terriqon';
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || '1.0.2';

export const TABLE_PAGE_SIZE = 10;
export const DEFAULT_PAGE_SIZE = 20;

export const SYNC_RETRY_ATTEMPTS = 3;
export const SYNC_RETRY_DELAY = 1000;
export const AUTO_SYNC_INTERVAL = 30000;

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  USER_DATA: 'user_data',
  LAST_SYNC: 'last_sync',
  OFFLINE_DATA: 'offline_data',
  SETTINGS: 'app_settings'
};

export const NETWORK_STATUS = {
  ONLINE: 'online',
  OFFLINE: 'offline',
  CONNECTING: 'connecting'
};

export const SYNC_STATUS = {
  IDLE: 'idle',
  SYNCING: 'syncing',
  SUCCESS: 'success',
  ERROR: 'error',
  CONFLICT: 'conflict'
};

export const FORM_STATUS = {
  DRAFT: 'draft',
  ACTIVE: 'active',
  ARCHIVED: 'archived'
};

export const SURVEY_STATUS = {
  DRAFT: 'draft',
  COMPLETED: 'completed',
  SUBMITTED: 'submitted'
};

export const OPERATION_TYPES = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE'
};

export default {
  APP_NAME,
  APP_VERSION,
  TABLE_PAGE_SIZE,
  DEFAULT_PAGE_SIZE,
  SYNC_RETRY_ATTEMPTS,
  SYNC_RETRY_DELAY,
  AUTO_SYNC_INTERVAL,
  STORAGE_KEYS,
  NETWORK_STATUS,
  SYNC_STATUS,
  FORM_STATUS,
  SURVEY_STATUS,
  OPERATION_TYPES
};